import React, { useState, useEffect } from "react";
import Box from "../../../components/dashboard/Box";
import Header from "../../../layout/Header";
import Sidebar from "../../../layout/Sidebar";
import { Spin, Collapse } from "antd";
import Bridge from "../../../constants/Bridge";
import Synopsis from "./Synopsis";

const Main = () => {
  const [totalEcasForms, setTotalEcasForms] = useState(0);
  const [uniqueParticipants, setUniqueParticipants] = useState(0);
  const [loading, setLoading] = useState(false);
  const [getActiveLink, setGetActiveLink] = useState(true);

  // on load component function
  useEffect(() => {
    getDashboardData();
  }, []);
  // get dashboard counts
  const getDashboardData = () => {
    setLoading(true);
    Bridge.ecas
      .dashboard()
      .then((result) => {
        if (result.status == "1") {
          console.log("result", result);
          setTotalEcasForms(result.data.total_ecas_forms);
          setUniqueParticipants(result.data.total_unique_participants);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log("Error: ", err);
        setLoading(false);
      });
  };
  const onChange = (key) => {
    console.log(key);
  };
  const items = [
    {
      key: "1",
      label: "Synopsis",
      children: (
        <div className="accordion-content">
          <p>
            <Synopsis />
          </p>
        </div>
      ),
    },
  ];
  return (
    <div>
      <div>
        <Header />
        <div className="row">
          <Sidebar />
          <div
            className="col-lg-10"
            style={{
              minHeight: "100vh",
              paddingLeft: "32px",
              paddingRight: "30px",
              marginLeft: "auto",
              backgroundColor: "#F5F5F5",
            }}
          >
            <Spin spinning={loading}>
              <div
                className="main-section dashboard"
                style={{ marginTop: 105 }}
              >
                <div>
                  <p
                    style={{
                      position: "relative",
                      fontSize: 32,
                      fontFamily: "Open Sans",
                      fontWeight: "bold",
                      color: "#1A4F83",
                      textAlign: "start",
                    }}
                    className="mb-4 mt-4"
                  >
                    ECAS
                  </p>
                  <p
                    style={{
                      position: "relative",
                      fontSize: 20,
                      fontFamily: "Open Sans",
                      fontWeight: "bold",
                      color: "#1A4F83",
                      textAlign: "start",
                    }}
                    className="mb-4"
                  >
                    REAL TIME STUDY STATISTICS
                  </p>
                  <div className="synopsis-accordion">
                    <div className="row" style={{ padding: "2%" }}>
                      <Collapse
                        items={items}
                        defaultActiveKey={[]}
                        onChange={onChange}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      backgroundColor: "white",
                      padding: "2%",
                      borderRadius: "19px",
                      maxWidth: "100%",
                      alignItems: "center",
                    }}
                  >
                    <div className="row" style={{ padding: "2%" }}>
                      <div className="col-lg-3">
                        <a
                          href="/ecas/list"
                          style={{
                            fontWeight: "regular",
                            fontSize: "18",
                          }}
                          className={`active-links ${
                            getActiveLink ? "active" : ""
                          }`}
                        >
                          <Box
                            title="Total ECAS Forms"
                            count={totalEcasForms}
                            getActiveLink={getActiveLink}
                          />
                        </a>
                      </div>
                      <div className="col-lg-3">
                        <a
                          href="#!"
                          style={{
                            fontWeight: "regular",
                            fontSize: "18",
                            cursor: "auto",
                          }}
                          // className={`active-links ${
                          //   getActiveLink ? "active" : ""
                          // }`}
                        >
                          <Box
                            title="Unique Participants"
                            count={uniqueParticipants}
                            getActiveLink={false}
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Spin>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Main;
